import React, { useContext, useMemo } from 'react';
import { Autocomplete, TextField, Pagination as PaginationComponent } from '@mui/material';

import pageSizeOptionsEnum from '../../../enums/pageSizeOptionsEnum';

import { userKeyStoreEnum } from '../../../enums/userKeyStoreEnum';
import { sessionKeyStoreEnum } from '../../../enums/sessionKeyStoreEnum';
import { UserContext, SessionContext } from '../../../context';

export default function Pagination() {
  const { userSettings = {}, updateUserSettings } = useContext(UserContext);
  const { sessionStore = {}, updateSessionStore } = useContext(SessionContext);

  const { previewPageSize } = useMemo(() => userSettings, [userSettings]);
  const { previewPageCount, previewPageIndex } = useMemo(() => sessionStore, [sessionStore]);

  const pageSizeOptionAsString = [...Object.values(pageSizeOptionsEnum)];
  const defaultPageIndex = 0;

  const updatePage = (newPageIndex) => {
    const newIndex = newPageIndex - 1;
    if (previewPageIndex == newIndex) {
      return;
    }
    updateSessionStore({ [sessionKeyStoreEnum.PREVIEW_PAGE_INDEX]: newIndex });
  };

  const updatePageSize = (newPageSize) => {
    if (newPageSize !== null) {
      const newPageSizeNumber = Number(newPageSize);
      if (previewPageSize === newPageSizeNumber) return;
      updateSessionStore({
        [sessionKeyStoreEnum.PREVIEW_PAGE_INDEX]: defaultPageIndex,
        [userKeyStoreEnum.PREVIEW_PAGE_SIZE]: newPageSizeNumber,
      });
      updateUserSettings({ [userKeyStoreEnum.PREVIEW_PAGE_SIZE]: newPageSizeNumber });
    }
  };

  return (
    <div style={container}>
      <div style={autocomplete}>
        <Autocomplete
          options={pageSizeOptionAsString}
          value={`${previewPageSize}`}
          onChange={(e, value) => updatePageSize(value)}
          renderInput={(params) => (
            <TextField
              {...params}
              color="primary"
              size="small"
              label="Number of Images Displayed"
            />
          )}
        />
      </div>
      <PaginationComponent
        showFirstButton
        showLastButton
        boundaryCount={1}
        siblingCount={0}
        count={previewPageCount || 1}
        page={(previewPageIndex || 0) + 1}
        onChange={(e, value) => updatePage(value)}
        color="primary"
        shape="rounded"
      />
    </div>
  );
}

const container = {
  display: 'flex',
  flexGrow: 1,
  alignItems: 'center',
};

const autocomplete = {
  maxWidth: '250px',
  width: '100%',
};
